import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import Landing from './views/Landing.vue'
import Home from './views/Home.vue'
import Calendar from './views/Calendar.vue'
import About from './views/About.vue'
import Visit from './views/Visit.vue'
import Artists from './views/Artists.vue'
import Tags from './views/Tags.vue'
import Live from './components/Live.vue'

Vue.use(Router)
// Vue.use(VueMeta, {
//   refreshOnceOnNavigation: true
// })
const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    if (to.name !== from.name) {
      if (savedPosition) {
        return savedPosition
      } else {
        return { x: 0, y: 0 }
      }
    }
  },
  routes: [
    {
      path: '/',
      name: 'landing',
      component: Landing
    },
    {
      path: '/home/:date?/:slug?',
      name: 'home',
      component: Home,
      beforeEnter: (to, from, next) => {
        store.dispatch('getEvents').then(() => {
          store.dispatch('getSiteContent').then(() => {
            next()
          })
        })
      }
    },
    {
      path: '/artists/:slug?',
      name: 'artists',
      component: Artists,
      meta: { name_fr: 'artistes' },
      beforeEnter: (to, from, next) => {
        store.dispatch('getEvents').then(() => {
          next()
        })
      }
    },
    {
      path: '/calendar/:date?/:slug?',
      name: 'calendar',
      component: Calendar,
      meta: { name_fr: 'agenda' },
      beforeEnter: (to, from, next) => {
        store.dispatch('getEvents').then(() => {
          next()
        })
      }
    },
    {
      path: '/about',
      name: 'about',
      meta: { name_fr: 'À propos' },
      component: About,
      beforeEnter: (to, from, next) => {
        store.dispatch('getSiteContent').then(() => {
          next()
        })
      }
    },
    {
      path: '/visit',
      name: 'visit',
      meta: { name_fr: 'Info pratiques' },
      component: Visit,
      beforeEnter: (to, from, next) => {
        store.dispatch('getSiteContent').then(() => {
          next()
        })
      }
    },
    {
      path: '/tag/:slug/:date?/:currentItemSlug?',
      name: 'tags',
      component: Tags,
      beforeEnter: (to, from, next) => {
        store.dispatch('getEvents').then(() => {
          next()
        })
      }
    },
    {
      path: '/live',
      name: 'live',
      component: Live,
      beforeEnter: (to, from, next) => {
        store.dispatch('getSiteContent').then(() => {
          next()
        })
      }
    },
    {
      path: '/*',
      redirect: '/home'
    }
  ]
})

router.beforeEach ((to, from, next) => {
  store.dispatch('init').then(() => {
    // // eslint-disable-next-line
    // _paq.push(['setCustomUrl', to.fullPath])
    // // eslint-disable-next-line
    // _paq.push(['trackPageView'])
    next()
    setTimeout(() => {
      window.prerenderReady = true
    }, 2500)
  })
})

export default router
